module.exports = __webpack_public_path__ + "static/media/website-screenshot.8bbb7ea6.png";